import { NetFetch } from '../Net/NetFetch';
import { UnauthorizedError } from './Error/UnauthorizedError';
import { StatusCodes } from './Status/StatusCodes';
/**
 * Blacklist API client — admin-only view of the IPs the rate limiter is
 * currently blocking, plus the unblock action.
 */
export class Blacklist {
    /**
     * The IPs currently blocked by the rate limiter.
     * @return {Promise<BlacklistEntry[]>}
     */
    static async getList() {
        var _a;
        const result = await NetFetch.postData('/json/blacklist/list', {});
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return (_a = result.list) !== null && _a !== void 0 ? _a : [];
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return [];
    }
    /**
     * Unblock (reset the rate limiter for) an IP.
     * @param {string} ip
     * @return {Promise<boolean>} true when the limiter key was reset
     */
    static async unblock(ip) {
        var _a;
        const result = await NetFetch.postData('/json/blacklist/unblock', { ip });
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return (_a = result.success) !== null && _a !== void 0 ? _a : false;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return false;
    }
    /**
     * Accounts/devices currently locked out after failed mobile logins.
     * @return {Promise<LoginLockoutEntry[]>}
     */
    static async getLockoutList() {
        var _a;
        const result = await NetFetch.postData('/json/login_lockout/list', {});
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return (_a = result.list) !== null && _a !== void 0 ? _a : [];
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return [];
    }
    /**
     * Lift a login lockout by its key.
     * @param {string} key
     * @return {Promise<boolean>}
     */
    static async unblockLockout(key) {
        var _a;
        const result = await NetFetch.postData('/json/login_lockout/unblock', { key });
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return (_a = result.success) !== null && _a !== void 0 ? _a : false;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return false;
    }
}
